import { EscalatorWarning, Face5, Person, PersonAddAlt } from "@mui/icons-material";
import TooltipComponent from "components/TooltipComponent";
import { t } from "i18next";
import { IRecognitionTypeOption, IRecognitionTypes } from "services/Recognition/types";

export const getRecognitionTypeLabel = (
    type: IRecognitionTypes,
  ): React.ReactNode => {
    switch (type) {
      case IRecognitionTypes.GENERAL:
        return (
          <TooltipComponent title={t('recognitionPage.registerFace.general')}>
            <Person color={'primary'} />
          </TooltipComponent>
        );
      case IRecognitionTypes.CUSTOMER:
        return (
          <TooltipComponent title={t('recognitionPage.registerFace.customer')}>
            <PersonAddAlt color={'warning'} />
          </TooltipComponent>
        );
      case IRecognitionTypes.STUDENT:
        return (
          <TooltipComponent title={t('recognitionPage.registerFace.student')}>
            <Face5 color={'success'} />
          </TooltipComponent>
        );
      case IRecognitionTypes.RESPONSIBLE:
        return (
          <TooltipComponent
            title={t('recognitionPage.registerFace.responsible')}
          >
            <EscalatorWarning color={'secondary'} />
          </TooltipComponent>
        );
      default:
        return 'Desconhecido';
    }
  };

export const getRecognitionTypesOptions = (): IRecognitionTypeOption[] => [
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.general'), value: IRecognitionTypes.GENERAL },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.customer'), value: IRecognitionTypes.CUSTOMER },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.student'), value: IRecognitionTypes.STUDENT },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.responsible'), value: IRecognitionTypes.RESPONSIBLE },
  ];